<template>
  <div>
    <template v-if="dataChart != null">
      <v-row class="ma-2" justify="center">
        <v-col cols="12" md="5" offset-md="1">
          <v-row dense>
            <v-col>
              <h4><v-icon class="ma-2" color="amber" x-large> mdi-gold</v-icon>{{ $t("savings.escb.economic") }}</h4>

              <i>{{ $t("savings.escb.lastMonth") }}</i>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12">
              <v-icon color="grey" x-large> mdi-transmission-tower-export</v-icon>{{ $t("savings.escb.originalExpensesMonth") }}: <b>{{ originalTotal }} Kč</b>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12">
              <v-icon color="amber" x-large> mdi-solar-power-variant</v-icon> {{ $t("savings.escb.currentSavingsMonth") }}: <b>{{ savedTotal }} Kč</b>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12">
              <v-icon color="pink" x-large> mdi-piggy-bank-outline</v-icon> {{ $t("savings.escb.currentExpensesMonth") }}: <b>{{ totalTotal }} Kč</b>
            </v-col>
          </v-row>

          <template v-if="$vuetify.breakpoint.mdAndUp">
            <br />
            <br />
          </template>

          <v-row dense>
            <v-col>
              <h4><v-icon class="ma-2" color="light-green" x-large> mdi-tree</v-icon> {{ $t("savings.escb.environmental") }}</h4>
              <i>{{ $t("savings.escb.lastMonth") }}</i>
            </v-col>
          </v-row>

          <v-row dense class="ma-2">
            <v-col cols="12">
              <v-icon color="grey" x-large> mdi-weather-snowy-heavy</v-icon> {{ $t("savings.co2") }}: <b>{{ CO2Saved }} {{ $t("savings.tons") }}</b>
            </v-col>
            <v-col cols="12">
              <v-icon color="blue-grey" x-large> mdi-cart</v-icon> {{ $t("savings.coal") }}: <b>{{ coalSaved }} {{ $t("savings.tons") }}</b>
            </v-col>
            <v-col cols="12">
              <v-icon color="green" x-large> mdi-forest</v-icon> {{ $t("savings.trees") }}: <b> {{ treesSaved }}</b>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" md="5">
          <v-row dense>
            <v-col>
              <h4>{{ $t("savings.escb.trendChart") }}</h4>
            </v-col>
          </v-row>

          <AnySparkLineChart :header="$t('savings.escb.originalChart')" :data="originalChart" :max="originalChartMax" :min="originalChartMin" :colors="['#AEEA00', '#8BC34A', '#4CAF50']" />
          <AnySparkLineChart :header="$t('savings.escb.savedChart')" :data="savedChart" :max="savedChartMax" :min="savedChartMin" :colors="['#03A9F4', '#00BCD4', '#009688']" />
          <AnySparkLineChart :header="$t('savings.escb.totalChart')" :data="totalChart" :max="totalChartMax" :min="totalChartMin" :colors="['#D50000', '#EF5350', '#F44336']" />
        </v-col>
      </v-row>

      <v-row justify="end">
        <v-col cols="6" md="2">
          <v-text-field :label="$t('savings.escb.priceDst')" v-model.number="priceDst" suffix="Kč" @input="recalculate()" @change="saveTarif()"></v-text-field>
        </v-col>

        <v-col cols="6" md="2">
          <v-text-field :label="$t('savings.escb.priceSup')" v-model.number="priceSup" suffix="Kč" @input="recalculate()" @change="saveTarif()"></v-text-field>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <LoadingData />
    </template>
  </div>
</template>

<script>
import AnySparkLineChart from "../../components/charts/AnySparkLineChart.vue";

import { ServiceClient } from "../../service_client/index.js";

import LoadingData from "../../components/LoadingData.vue";

export default {
  name: "Savings",
  components: {
    AnySparkLineChart,
    LoadingData,
  },
  data() {
    return {
      timer: null,

      originalTotal: 0,
      savedTotal: 0,
      totalTotal: 0,

      originalChart: [],
      savedChart: [],
      totalChart: [],

      originalChartMin: 0,
      savedChartMin: 0,
      totalChartMin: 0,

      originalChartMax: 0,
      savedChartMax: 0,
      totalChartMax: 0,

      coalSaved: 0,
      CO2Saved: 0,
      treesSaved: 0,

      priceDst: 7,
      priceSup: 4,

      dataChart: null,
    };
  },
  created() {
    this.getChartLastMonth();

    this.loadTarif();
    this.recalculate();
  },
  mounted() {
    this.pollData();
  },
  methods: {
    loadTarif() {
      if (localStorage.getItem("tarifESCBDst") !== null) {
        this.priceDst = localStorage.getItem("tarifESCBDst");
      }
      if (localStorage.getItem("tarifESCBSup") !== null) {
        this.priceSup = localStorage.getItem("tarifESCBSup");
      }
    },
    saveTarif() {
      localStorage.setItem("tarifESCBDst", this.priceDst);
      localStorage.setItem("tarifESCBSup", this.priceSup);
    },
    recalculate() {
      this.processChartData(this.dataChart);
    },
    pollData() {
      this.timer = setInterval(() => {
        this.getChartLastMonth();
      }, 60000);
    },
    processChartData(data) {
      this.originalChart = [];
      this.savedChart = [];
      this.totalChart = [];

      this.originalTotal = 0;
      this.savedTotal = 0;
      this.totalTotal = 0;

      for (let index = 0; index < data.labels.length; index++) {
        let consumption = data.gridImp[index] * this.priceDst;

        let total = data.gridDst[index] * this.priceDst + data.gridSup[index] * this.priceSup;

        let saved = consumption - (data.gridDst[index] * this.priceDst + data.gridSup[index] * this.priceSup);

        this.originalChart.push(consumption);
        this.originalTotal += consumption;

        this.savedChart.push(saved);
        this.savedTotal += saved;

        this.totalChart.push(total);
        this.totalTotal += total;
      }

      this.coalSaved = this.dataChart.gridSup.reduce((acc, curr) => acc + curr, 0) / 2460;
      this.CO2Saved = (this.dataChart.gridSup.reduce((acc, curr) => acc + curr, 0) * 1.011511) / 1000;
      this.treesSaved = this.dataChart.gridSup.reduce((acc, curr) => acc + curr, 0) * 0.0117;

      this.coalSaved = Math.round(this.coalSaved * 10000) / 10000;
      this.CO2Saved = Math.round(this.CO2Saved * 1000) / 1000;
      this.treesSaved = Math.round(this.treesSaved * 100) / 100;

      this.originalTotal = Math.round(this.originalTotal * 100) / 100;
      this.savedTotal = Math.round(this.savedTotal * 100) / 100;
      this.totalTotal = Math.round(this.totalTotal * 100) / 100;

      this.originalChartMin = Math.round(Math.min(...this.originalChart) * 100) / 100;
      this.savedChartMin = Math.round(Math.min(...this.savedChart) * 100) / 100;
      this.totalChartMin = Math.round(Math.min(...this.totalChart) * 100) / 100;

      this.originalChartMax = Math.round(Math.max(...this.originalChart) * 100) / 100;
      this.savedChartMax = Math.round(Math.max(...this.savedChart) * 100) / 100;
      this.totalChartMax = Math.round(Math.max(...this.totalChart) * 100) / 100;
    },

    getChartData(dt1, dt2) {
      let parameters = "?time=d" + "&type=E" + "&limit=31";

      if (dt1 != null && dt2 != null) {
        parameters += "&dt1=" + dt1 + "&dt2=" + dt2;
      }

      ServiceClient.dataCore(ServiceClient.getAPIUrl("escbchart"), null, parameters, "GET")
        .then((data) => {
          this.dataChart = data;

          this.processChartData(this.dataChart);
        })
        .catch((error) => {
          this.dataChart = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    getChartLastMonth() {
      this.getChartData(null, null);
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  destroyed() {},
};
</script>

<style scoped></style>
